/**
 * Helpers for determining whether a Patient id matches cohort membership
 * (subject lists and FHIR-search id.keyword queries).
 */

export type CohortLike = {
  id: string;
  name: string;
  subjectIds?: string[];
};

export const normalizePatientIdKeyword = (patientId: string): string =>
  patientId.includes('/') ? patientId.split('/').pop() || patientId : patientId;

export const buildPatientIdKeywordSelectQuery = (patientId: string) => {
  const id = normalizePatientIdKeyword(patientId);
  return {
    type: 'select' as const,
    limit: [
      { type: 'number' as const, value: 0 },
      { type: 'number' as const, value: 1 },
    ],
    columns: '*',
    from: [{ table: 'patient' }],
    where: {
      type: 'elasticsearch',
      query: {
        terms: {
          'id.keyword': [id],
        },
      },
    },
  };
};

export const cohortContainsPatientBySubjectIds = (
  cohort: Pick<CohortLike, 'subjectIds'>,
  patientId: string,
): boolean | 'unknown' => {
  const ids = cohort.subjectIds;
  if (!ids || ids.length === 0) {
    return 'unknown';
  }
  const norm = normalizePatientIdKeyword(patientId);
  return ids.some(sid => normalizePatientIdKeyword(String(sid)) === norm);
};
